import gql from 'graphql-tag'

export const GET_ALL_ADVISORY_LOGS = gql`
  query GetAllAdvisoryLogs($limit: Int, $skip: Int, $where: AdvisoryLogFilterInput, $orderBy: AdvisoryLogOrderInput) {
    getAllAdvisoryLogs(limit: $limit, skip: $skip, where: $where, orderBy: $orderBy) {
      data {
        id
        clientCode
        activityType
        activity
        source
        data
        createdAt
      }
      count
    }
  }
`